import { ifNotAuthenticated } from "./guards"
export default [
  {
    path: "/login",
    name: "Login",
    meta: { title: "Prijava" },
    component: () => import(/* webpackChunkName: "Auth" */ "@/Modules/User/Views/Auth/Login.vue"),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/login/forgot-password",
    name: "Forgot password",
    meta: { title: "Ponastavitev gesla" },
    component: () => import(/* webpackChunkName: "Auth" */ "@/Modules/User/Views/Auth/ForgotPassword.vue")
    // beforeEnter: ifNotAuthenticated
  },
  {
    path: "/login/reset-password",
    name: "Reset password",
    meta: { title: "Novo geslo" },
    component: () => import(/* webpackChunkName: "Auth" */ "@/Modules/User/Views/Auth/ResetPassword.vue")
    // beforeEnter: ifNotAuthenticated
  },
  // {
  //   path: "/settings",
  //   name: "settings",
  //   meta: { title: "Settings" },
  //   component: () => import(/* webpackChunkName: "Settings" */ "@/Modules/User/Views/Settings/Details.vue")
  //   // beforeEnter: ifAuthenticated
  // }
  {
    path: "/user-management",
    name: "User management list",
    meta: { title: "Nadzor uporabnikov" }, // guard: "User"
    component: () => import(/* webpackChunkName: "UserManagement" */ "@/Modules/User/Views/Management/List.vue")
    // beforeEnter: ifAuthenticated
  },
  {
    path: "/user-management/:id",
    name: "User management",
    component: () => import(/* webpackChunkName: "UserManagement" */ "@/Modules/User/Views/Management/Details/View.vue")
    // beforeEnter: ifAuthenticated
  }
]
